module.exports = __webpack_public_path__ + "img/arrow_back.26796fc4.svg";